import {Contribution} from "../utils/types";


export const contribution_dump: Contribution[] = [
    {
        id: '1',
        username: 'Benjamin',
        user_avatar: 'https://i.pravatar.cc/150?img=3',
        part_type: 'Soprano',
        song_title: 'Praise your name',
        song_artist: 'Benjamin Dube',
        file_url: '/audio_1.mp3',
        listens: 999,
        likes: 1100,
        comments: 12,
        createdAt: '2023-12-08T20:28:40.464875',
        updatedAt: '2023-12-08T20:28:40.464883',
    },
    {
        id: '2',
        username: 'Tom Lee',
        user_avatar: 'https://i.pravatar.cc/150?img=3',
        part_type: 'Alto',
        song_title: 'Jesus Iye',
        song_artist: 'Nathaniel Bassey',
        file_url: '/audio_2.mp3',
        listens: 200000,
        likes: 1223,
        comments: 22,
        createdAt: '2023-12-08T20:28:40.464891',
        updatedAt: '2023-12-08T20:28:40.464893',
    },
    {
        id: '3',
        username: 'Favour',
        user_avatar: 'https://i.pravatar.cc/150?img=3',
        part_type: 'Tenor',
        song_title: 'Praise your name',
        song_artist: 'Chris Tomlin',
        file_url: '/audio_3.m4a',
        listens: 367000,
        likes: 334567887,
        comments: 332,
        createdAt: '2023-12-08T20:28:40.464897',
        updatedAt: '2023-12-08T20:28:40.464899',
    }
];